import find from 'lodash/find';

import { Tiers, getTier } from 'xm-constants/productTiers';
import * as featureTogglesActions from 'actions/featureToggles';
import * as productTypeInfoActions from 'actions/productTypeInfo';

const getDefaultState = () => ({
  // From xm api:
  applyTrialLimits: false,
  productTier: '',
  isFreeTier: false,
  isTrialTier: false,

  // From GWT:
  trialInfo: {
    expiryDate: 0,
    conference: 'OK',
    sms: 'OK',
    voice: 'OK',
  },

  // From GWT. Remove when all trial users are either expired or on xMattersForTeams trials:
  // Currently only used to know to ignore feature toggles tier
  isLegacyTrial: false,
});

const onFeatureTogglesLoad = (state, payload) => {
  const { data } = payload;
  const applyTrialLimitsItem = find(data, { name: 'VIRAL_TRIAL_APPLY_LIMITS' });
  const productTierItem = find(data, { name: 'PRODUCT_TIER' });

  const applyTrialLimits =
    !!applyTrialLimitsItem && applyTrialLimitsItem.value === 'true';
  const productTier = !!productTierItem && getTier(productTierItem.value);

  return {
    applyTrialLimits,
    isFreeTier: productTier === Tiers.FREE,
    isTrialTier: productTier === Tiers.TRIAL,
    productTier: productTier || '',
  };
};

export default function productTypeInfo(state = getDefaultState(), action) {
  switch (action.type) {
    case productTypeInfoActions.PRODUCT_TYPE_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case featureTogglesActions.LOAD_SUCCESS:
      return {
        ...state,
        ...onFeatureTogglesLoad(state, action.payload),
      };
    default:
      return state;
  }
}
